import { EntitySelectEntity, EntitySelectSubEntity } from '@factorialco/f0-react/dist/experimental'
import {
  BenefitsEmployeeSelectorLegalEntityFragment,
  BenefitsNameForSelectFragment,
} from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

export function groupByLegalEntities(
  employees?: BenefitsNameForSelectFragment[],
  legalEntities: BenefitsEmployeeSelectorLegalEntityFragment[] = [],
  excludedIds: number[] = [],
  expandedElements: number[] = []
): EntitySelectEntity[] {
  if (!employees || !legalEntities.length) {
    return []
  }

  const legalEntityMap = new Map<number, EntitySelectEntity>()

  employees.forEach((employee) => {
    const { id, fullName, avatar, firstName, lastName, preferredName } = employee

    if (excludedIds.includes(id)) {
      return
    }

    const employeeGroupId = employee.employeeGroupId

    legalEntities.forEach((legalEntity) => {
      const employeeGroupIds = legalEntity.employeeGroups.map((group) => group.id)

      if (employeeGroupId && employeeGroupIds.includes(employeeGroupId)) {
        let legalEntityGroup = legalEntityMap.get(legalEntity.id)

        if (!legalEntityGroup) {
          legalEntityGroup = {
            id: legalEntity.id,
            name: legalEntity.legalName,
            expanded: expandedElements.includes(legalEntity.id),
            subItems: [],
          }
          legalEntityMap.set(legalEntity.id, legalEntityGroup)
        }

        const subItem: EntitySelectSubEntity = {
          subId: id,
          subName: fullName,
          subAvatar: avatar ? buildUrl(avatar.url) : undefined,
          subSearchKeys: [
            preferredName ? `${preferredName} ${lastName}` : null,
            `${firstName} ${lastName}`,
          ].filter(Boolean),
        }

        legalEntityGroup.subItems?.push(subItem)
      }
    })
  })

  const result = Array.from(legalEntityMap.values())

  return result
}
